import { IconProps } from "ztypes/icon-props";

const IconSearch: React.FunctionComponent<IconProps> = (props) => {
  return (
    <svg
      className={props.className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="zstyle-icon/search">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.5 8.75C3.5 5.85051 5.85051 3.5 8.75 3.5C11.6495 3.5 14 5.85051 14 8.75C14 11.6495 11.6495 14 8.75 14C5.85051 14 3.5 11.6495 3.5 8.75ZM8.75 2C5.02208 2 2 5.02208 2 8.75C2 12.4779 5.02208 15.5 8.75 15.5C10.3438 15.5 11.8085 14.9476 12.9633 14.0239C12.9654 14.026 12.9675 14.0282 12.9697 14.0303L16.7197 17.7803C17.0126 18.0732 17.4874 18.0732 17.7803 17.7803C18.0732 17.4874 18.0732 17.0126 17.7803 16.7197L14.0303 12.9697C14.0282 12.9675 14.026 12.9654 14.0239 12.9633C14.9476 11.8085 15.5 10.3438 15.5 8.75C15.5 5.02208 12.4779 2 8.75 2Z"
          fill="#212121"
          fillOpacity="0.7"
        />
      </g>
    </svg>
  );
};

export default IconSearch;
